"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  commonReport: {
    noData: '暂无数据'
  },
  ispCommon: {
    correctPrompt: '请选择正确的数据',
    //保存
    saveSuccess: '保存成功',
    saveError: '保存失败，请稍后再试',
    //新增
    addSuccess: '新增成功',
    addError: '新增失败，请稍后再试',
    //编辑
    editSuccess: '编辑成功',
    editError: '编辑失败，请稍后再试',
    //删除
    delSuccess: '删除成功',
    delError: '删除失败，请稍后再试',
    delSelect: '请选择需要删除的数据',
    delConfirm: '是否确认删除该数据？',
    //导出
    exportSuccess: '导出成功',
    exportError: '导出失败，请稍后再试',
    exportSelect: '请选择需要导出的数据',
    //导入
    importSuccess: '导入成功',
    importError: '导入失败，请稍后再试',
    importSelect: '请选择需要导入的数据',
    //计算相关
    recalculateConfirm: '是否确认重新计算？',
    calculateSuccess: '计算成功',
    calculateError: '计算失败，请稍后再试',
    //冲销提示
    writeOffSelect: '请选择需要冲销的数据',
    writeOffSuccess: '冲销成功',
    writeOffError: '冲销失败，请稍后再试',
    writeOffConfirm: '是否确认进行冲销？',
    //生成相关（合同、万能单等）
    createSuccess: '生成成功',
    createError: '生成失败，请稍后再试',
    //万能单相关
    receiptConfirm: '是否确认生成万能单？',
    generateReceiptFrist: '请先生成万能单',
    //审核相关
    submitApprovalConfirm: '是否确认提交审核？',
    unSubmitApprovalConfirm: '是否确认取消审核？',
    approvalSuccess: '审核成功',
    approvalError: '审核失败，请稍后再试',
    //其他
    allStatus: '全部',
    toBeSend: '待发送',
    sending: '发送中',
    sendSuccess: '发送成功',
    sendError: '发送失败'
  }
};